@if (facade.row(); as r) {
<div class="info-card order-key-info">
      <div class="info-card__head">
        <h2 class="info-card__title">{{
          'admin.storageRequests.sectionKeyInfo' | translate
        }}</h2>
        @if (facade.canEditOrder()) {
        <lib-not-button
          class="info-card__edit-btn"
          [text]="'admin.storageRequests.editOrder' | translate"
          [color]="'#140342'"
          [bgColor]="'rgba(55, 190, 176, 0.12)'"
          [width]="'auto'"
          [size]="'medium'"
          [action]="{ type: 'action' }"
          [disabled]="facade.saving()"
          (actionEvent)="facade.openEditOrderDialog()"
        />
        }
      </div>

      @if (r.pickup_address) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          r.type === 'moving'
            ? ('admin.storageRequests.fromAddress' | translate)
            : r.client_self_dropoff
              ? ('admin.storageRequests.receiveWarehouseLabel' | translate)
            : ('admin.storageRequests.pickupAddress' | translate)
        }}</span>
        <span class="info-value info-value--multiline">{{
          r.pickup_address
        }}</span>
      </div>
      }

      @if (r.delivery_address) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          r.type === 'moving'
            ? ('admin.storageRequests.toAddress' | translate)
            : ('admin.storageRequests.deliveryAddressLabel' | translate)
        }}</span>
        <span class="info-value info-value--multiline">{{
          r.delivery_address
        }}</span>
      </div>
      }

      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.warehouseLabel' | translate
        }}</span>
        <span class="info-value">
          @if (facade.warehouseLoading()) {
          {{ 'common.loading' | translate }}
          } @else {
          {{ facade.warehouseDisplay(r) }}
          }
        </span>
      </div>

      @if (r.preferred_at) {
      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.preferredAt' | translate
        }}</span>
        <span class="info-value">{{
          r.preferred_at | date:'dd.MM.yyyy, HH:mm'
        }}</span>
      </div>
      }

      @if (r.scheduled_at) {
      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.orderScheduledAt' | translate
        }}</span>
        <span class="info-value">{{
          r.scheduled_at | date:'dd.MM.yyyy, HH:mm'
        }}</span>
      </div>
      }

      @if (facade.pricingEstimateNowAmount(r) !== null) {
      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.orderEstimateNowLabel' | translate
        }}</span>
        <span class="info-value">{{
          facade.formatBynd(facade.pricingEstimateNowAmount(r)!)
        }}</span>
      </div>
      }

      @if (facade.pricingEstimateDeclaredVolume(r) !== null) {
      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.orderDeclaredVolumeLabel' | translate
        }}</span>
        <span class="info-value">
          {{
            'admin.storageRequests.orderDeclaredVolumeValue'
              | translate: {
                  volume: facade.formatVolumeM3(
                    facade.pricingEstimateDeclaredVolume(r)!
                  ),
                }
          }}
        </span>
      </div>
      }

      @if (r.type === 'delivery') {
      <div class="info-row">
        <span class="info-label">{{
          'admin.storageRequests.returnToWarehouseLabel' | translate
        }}</span>
        <span class="info-value">{{
          (r.return_to_warehouse ? 'common.yes' : 'common.no') | translate
        }}</span>
      </div>
      }

      @if (r.access_description) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          'admin.storageRequests.accessDescriptionLabel' | translate
        }}</span>
        <span class="info-value info-value--multiline info-value--pre">{{
          r.access_description
        }}</span>
      </div>
      }

      @if (r.items_description) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          r.type === 'moving'
            ? ('admin.storageRequests.cargoDescription' | translate)
            : ('admin.storageRequests.itemsDescription' | translate)
        }}</span>
        <span class="info-value info-value--multiline info-value--pre">{{
          r.items_description
        }}</span>
      </div>
      }

      @if (r.notes) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          'admin.storageRequests.clientNotes' | translate
        }}</span>
        <span class="info-value info-value--multiline info-value--pre">{{
          r.notes
        }}</span>
      </div>
      }

      @if (r.staff_notes) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          'admin.storageRequests.managerNote' | translate
        }}</span>
        <span class="info-value info-value--multiline info-value--pre">{{
          r.staff_notes
        }}</span>
      </div>
      }

      @if (r.cancel_reason) {
      <div class="info-row info-row--stacked info-row--warning">
        <span class="info-label">{{
          (r.canceled_by && r.user_id && r.canceled_by === r.user_id
            ? 'admin.storageRequests.clientCancelReason'
            : 'admin.storageRequests.cancelReason') | translate
        }}</span>
        <span class="info-value info-value--multiline info-value--pre">{{
          r.cancel_reason
        }}</span>
      </div>
      }

      @if (r.movers && r.movers.length > 0) {
      <div class="info-row info-row--stacked">
        <span class="info-label">{{
          'admin.storageRequests.assignedMoversTitle' | translate
        }}</span>
        <ul class="assigned-movers">
          @for (m of r.movers; track m.mover_id) {
          <li class="assigned-movers__item">
            <span class="assigned-movers__name">{{
              facade.moverDisplayName(m.mover_id)
            }}</span>
            @if (m.is_lead) {
            <span class="assigned-movers__lead">{{
              'admin.storageRequests.assignedMoversLead' | translate
            }}</span>
            }
          </li>
          }
        </ul>
      </div>
      }
    </div>
}
